import React from 'react'
import PropTypes from 'prop-types'
import Map from 'components/shared/map/selector'

const INITIAL_COORDINATES = {
  lat: 14.5995,
  lng: 120.98,
  zoom: 11,
}

const LocationSelectField = ({ input, meta, groupClassName = 'relative h-64 my-5', errorClassName }) => {
  const coord = { ...INITIAL_COORDINATES, ...input.value }

  return <div className={groupClassName}>
    <Map onMarkerMove={value => input.onBlur(value)} {...coord} />
    {meta.touched && meta.error && <p className={`form-error ${errorClassName}`}>{meta.error}</p>}
  </div>
}

LocationSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  groupClassName: PropTypes.string,
  errorClassName: PropTypes.string,
}

export default LocationSelectField
